import $ from 'jquery';
import Parallax from './Parallax';
import BackgroundImage from './BackgroundImage';

function Hero(element) {
  this.element = element;
  this.$element = $(element);
  this.parallax = this.addParallax();
  this.bgImage = this.addBackgroundImage();
  this.seeMore = this.addSeeMore();
  this.formatTitle();
}

Hero.prototype = {
  addParallax() {
    // Add an element to add a background to, in addition to adding a parallax effect on scroll.
    this.$element.find('.node').prepend('<span class="parallax"></span>');
    return new Parallax(this.element, { targetSelector: '.parallax' });
  },
  addBackgroundImage() {
    return new BackgroundImage(this.element, { destSelector: '.parallax' });
  },
  addSeeMore() {
    const $button = $('<button class="see-more" role="button">See more</button>');
    $button.on('click', () => {
      const offset = $('#content').offset().top - 115;
      const scrollNode = document.scrollingElement ? document.scrollingElement : document.body;
      $(scrollNode).animate({ scrollTop: offset }, 500);
    });
    this.$element.append($button);
  },
  formatTitle() {
    this.$element.find('.title').each((i, title) => {
      let html = '';
      const aTitle = $(title).html().split('<br>');
      $.each(aTitle, (k, snippet) => {
        html += `<span>${snippet}</span>`;
        if (k < aTitle.length - 1) {
          html += '<br>';
        }
      });
      $(title).html(html);
    });
  },
};

export default Hero;



// WEBPACK FOOTER //
// ./Hero.js